import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { drawCanvas } from '../../../utils/helper.';

@Component({
  selector: 'app-canvas-preview',
  standalone: true,
  imports: [],
  templateUrl: './canvas-preview.component.html',
  styleUrl: './canvas-preview.component.scss'
})
export class CanvasPreviewComponent {
  @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  @Input() drawData:any;
  @Input() height = 80;
  @Input() width = 80;

  ngAfterViewInit(): void {
    const url = this.drawData?.artThumbnailUploadUrl || this.drawData?.artThumbnailUrl || this.drawData?.artUploadUrl || this.drawData?.imageUrl || this.drawData?.artThumbnailUrls?.[0] || this.drawData?.artUploadUrls?.[0]
    let sign = ''
    if(!this.drawData?.signature) {
      sign = this.drawData?.artistName;
    } else {
      sign = this.drawData?.signature;
    }
    
    drawCanvas(
      this.canvasRef.nativeElement,
      url,
      this.drawData?.isWatermarkEnable || this.drawData?.watermark || this.drawData?.waterMark,
      sign,
      this.drawData?.artistName,
      this.width,
      this.height,
      25
    )
  }
}
